import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';

const SummaryDivider = ()=>/*#__PURE__*/ React.createElement(Hr, {
        className: "configuration-summary-divider__line"
    })
;
const ConfigurationSummaryDivider = ({ isSmallScreen , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('configuration-summary-divider', className)
    }, isSmallScreen ? /*#__PURE__*/ React.createElement(SummaryDivider, null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SummaryDivider, null), /*#__PURE__*/ React.createElement(SummaryDivider, null), /*#__PURE__*/ React.createElement(SummaryDivider, null)))
;

export { ConfigurationSummaryDivider, SummaryDivider };
//# sourceMappingURL=ConfigurationSummaryDivider.js.map
